import React, { PureComponent } from 'react';
import {
  LineChart, PieChart, Pie, Sector, Cell, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer, AreaChart, Area
} from 'recharts';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const COLORS = ['#ea8b0e', '#89756a'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx, cy, midAngle, innerRadius, outerRadius, percent, index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};


export class ProductMetrics extends React.Component {


  render() {
    return (
      <div>
        <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 40 }}>
          <b>Ventas semanales</b>
        </Typography>
        <ResponsiveContainer width={800} height={300}>
          <LineChart
            width={700}
            height={300}
            data={this.props.metrics.line_chart}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="Productos" stroke="#ea8b0e" activeDot={{ r: 7 }} />
          </LineChart>
        </ResponsiveContainer>
        <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 40 }}>
          <b>Sin stock/Recarga stock</b>
        </Typography>
        <ResponsiveContainer width={800} height={300}>
          <AreaChart data={this.props.metrics.stock_variation}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Area connectNulls={true} type='monotone' dataKey='stock' stroke="#ea8b0e" fill='#89756a' />
          </AreaChart>
        </ResponsiveContainer>
        <div className='col-md-6' style={{ marginTop: 40 }}>
          <Typography variant="h6" id="tableTitle">
            Mejores Compradores
          </Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell align="center">Cliente</TableCell>
                <TableCell align="center">total de Items</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.metrics.best_customers.map(row => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    {row.id}
                  </TableCell>
                  <TableCell align="center">{row.customer}</TableCell>
                  <TableCell align="center">{row.items}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div style={{ marginTop: 22 }}>
          <Typography variant="subtitle1">
            <b> Ultima venta: </b>{this.props.metrics.last_sell}
          </Typography>
          <Typography variant="subtitle1">
            <b> Promedio de items por venta: </b>{this.props.metrics.avg_items_per_buy}
            <Typography variant="caption">
            <b>  *Ultimo mes</b>
          </Typography>
          
          </Typography>
          </div>
        </div>
        <div className='col-md-5 col-md-offset-1' style={{ marginTop: 40 }}>
          <Typography variant="subtitle2">
            Ventas Producto vs total de ventas de {this.props.productType}s

          </Typography>
          <Typography variant="caption">
            Ultimo mes
          </Typography>
          <PieChart style={{marginLeft: 30}} width={400} height={400}>
            <Pie
              data={this.props.metrics.pie_chart}
              cx={100}
              cy={100}
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >

              {
                this.props.metrics.pie_chart.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
              }
            </Pie>
          </PieChart>

        </div>
        </div>
        )
      }
}


// WEBPACK FOOTER //
// ./src/components/Products/ProductMetrics.js